<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div id="listloader" v-if="isLoading">
          <div class="listloader"></div>
      </div>
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>{{route_id=='normal'?'New Zone Management':'Vendor Zone Management'}}</strong>
            <div
              class="card-header-actions"
            >
              <b-button  v-if="User_type == 2 && isReadOnly==false" size="sm"
                class="btn btn-sm btn-primary mr-4 "
                data-toggle="tooltip"
                variant="primary"
                 @click="addNewZone = !addNewZone">
                {{route_id=='normal'? 'Add Zone' : 'Add Vendor Zone'}}
              </b-button>
            </div>
          </div>

          <div>
            <b-collapse id="Zone" v-model="addNewZone">
              <b-card>
                <b-form
                  @submit.prevent="validateForm('form-1')"
                  data-vv-scope="form-1"
                >
                  <b-col md="12">
                    <b-row>
                      <b-col sm="6">
                        <b-form-group>
                          <b-row>
                            <b-col :sm="route_id=='normal'? 4 : 5">
                              <strong>{{route_id=='normal'?'Zone Name' :'Vendor Zone Name'}}</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col :sm="route_id=='normal'? 8 : 7">
                              <b-form-input
                              class="input"
                              type="text"
                              v-model="Customer.zone_name"
                              name="Zone_name"
                              v-validate="'required|alpha_spaces'"
                              :class="{
                                input: true,
                                'text-invalid': errors.has('form-1.Zone_name'),
                              }"
                              placeholder="Enter Zone Name"
                            >
                            </b-form-input>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-1.Zone_name')"
                                  >{{ errors.first("form-1.Zone_name") }}</i
                                >
                              </span>
                            </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6">
                        <b-form-group>
                          <b-row>
                            <b-col :sm="route_id== 'normal' ? 4 : 5">
                              <strong> {{ route_id=='normal'?'Zone Number':'Vendor Zone Number' }}</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col :sm="route_id== 'normal' ? 8 : 7">
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Customer.zone_number"
                                name="Zone_number"
                                v-validate="'required|regex:^[A-Za-z0-9-]+$'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has('form-1.Zone_number'),
                                }"
                                placeholder="Enter Zone Number"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.Zone_number')"
                                    >{{ errors.first("form-1.Zone_number") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6">
                        <b-form-group>
                          <b-row>
                            <b-col sm="3">
                              <strong>Select Type</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col sm="9">
                              <b-form-radio-group
                                v-model="Customer.selectedredio"
                                :options="options"
                                class="mt-2"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                                name="Zone_check"
                                v-validate="'required'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has('form-1.Zone_check'),
                                }"
                              >
                              </b-form-radio-group>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.Zone_check')"
                                    >{{ errors.first("form-1.Zone_check") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group>
                          <b-row>
                            <b-col sm="4">
                              <strong>Length (in Feet)</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col sm="8">
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Customer.length"
                                name="length"
                                v-validate="'required|decimal:3'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has('form-1.length'),
                                }"
                                placeholder="Enter Box Length"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.length')"
                                    >{{ errors.first("form-1.length") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group>
                          <b-row>
                            <b-col sm="4">
                              <strong>Breadth (in Feet)</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col sm="8">
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Customer.breadth"
                                name="breadth"
                                v-validate="'required|decimal:3'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has('form-1.breadth'),
                                }"
                                placeholder="Enter Box Breadth"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.breadth')"
                                    >{{ errors.first("form-1.breadth") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group>
                          <b-row>
                            <b-col sm="4">
                              <strong>Height (in Feet)</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                            </b-col>
                            <b-col sm="8">
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Customer.height"
                                name="height"
                                v-validate="'required|decimal:3'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has('form-1.height'),
                                }"
                                placeholder="Enter Box Height"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.height')"
                                    >{{ errors.first("form-1.height") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6" v-if="route_id=='normal'">
                        <label class="mt-2 square-checkbox" style="display: flex; align-items: center; cursor: pointer;">
                          <input type="checkbox" name="is_rto_zone" value="yes" :checked="Customer.is_rto_zone === 'yes'" @change="Customer.is_rto_zone = $event.target.checked ? 'yes' : 'no'" style="margin-right: 8px;" />
                          <span>Is RTO zone?</span>
                        </label>
                      </b-col>

                      <b-col sm="6" v-if="route_id=='asn'">
                        <b-form-radio-group
                            v-model="Customer.zone_for"
                            :options="huboptions"
                            @input="getCityList('add',Customer.zone_for)"
                            class="mt-2 selectbutton"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                            name="vendor_Zone_check"
                            v-validate="'required'"
                            :class="{
                              input: true,
                              'text-invalid': errors.has('form-1.vendor_Zone_check'),
                            }"
                          >
                        </b-form-radio-group>
                        <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-1.vendor_Zone_check')"
                                >{{ errors.first("form-1.vendor_Zone_check") }}</i
                              >
                            </span>
                        </b-input-group>
                      </b-col>

                      <b-col sm="6"  class="mt-4"  v-if="route_id=='asn' && Customer.zone_for=='is_vendor'">
                        <div v-if="Customer.selectedredio == 'Dock'">
                          <b-form-group label="Map Zone To City :" :label-cols="4">
                            <div id='container'>
                                <ejs-multiselect  id='multi_select2'  placeholder="Please Select City" v-model="Customer.selected_mapcity" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox"></ejs-multiselect>
                            </div> 
                          </b-form-group>
                        </div>

                        <div v-else>
                          <b-form-group>
                            <b-row>
                              <b-col sm="4">
                                <strong>Map Zone To City</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                              </b-col>
                              <b-col sm="8">
                                <div id='container'>
                                  <ejs-multiselect  id='multi_select2'  placeholder="Please Select City" v-model="Customer.selected_mapcity" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                  name="Select_City"
                                  v-validate="'required'"
                                  :class="{
                                    input: true,
                                    'text-invalid': errors.has('form-1.Select_City'),
                                  }" ></ejs-multiselect>
                              </div> 
                              </b-col>
                            </b-row>
                          </b-form-group>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-1.Select_City')"
                                >{{ errors.first("form-1.Select_City") }}</i
                              >
                            </span>
                          </b-input-group>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <footer class="column has-text-right">
                    <div v-if="(route_id=='asn' && Customer.zone_for=='is_vendor')|| (route_id=='normal')">
                      <b-button
                      variant="primary"
                      size="md"
                      type="submit"
                      style="float: right;"
                      >ADD</b-button
                    >
                    </div>
                  </footer>
                </b-form>
              </b-card>
            </b-collapse>
          </div>

          <div v-if="User_type==1">
            <div class="accordion" role="tablist" v-if="hubcount_length>0">
              <b-card no-body class="mb-1" v-for="(item, index) in hubCount" :key="item.hub_id">
                <b-card-header header-tag="header" v-bind:id="'collapse' + index" @click=" ZoneListings(item.hub_id);" class="p-1" role="tab">
                  <b-button block v-b-toggle="'accordion-' + item.hub_id" variant="info">
                    <b-row>
                      <b-col sm="3" title="Hub ID">#{{item.hub_id}}
                      </b-col>
                      <b-col sm="6" title="Hub Title">Hub Title : {{item.hub_title}}
                      </b-col>
                    </b-row>
                  </b-button>
                </b-card-header>
                <b-collapse class="'accordion-' + item.hub_id" v-bind:id="'accordion-' + item.hub_id"  accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-row>
                      <b-col sm="12" class="text-right  " >
                          <b>Total Records:<span style="color:red;">{{ totalRows }}</span></b> 
                       
                        </b-col>
                      <b-col md="12">
                        <b-table
                          show-empty
                          responsive
                          :items="zonelist"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :fields="fieldsasn"
                          :per-page="perPage"
                          :filter="filter"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :sort-direction="sortDirection"
                          :bordered="bordered" 
                        >
                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                          <template slot="zone_city" slot-scope="row">
                            <div>
                              <b-button
                                size="sm"
                                @click="viewcityModal(row.item)"
                                data-toggle="tooltip"
                                title="View City Details"
                              >
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            </b-button>&nbsp;
                            </div>
                          </template>
                          <template slot="zone_status" slot-scope="row" >
                           
                              <span data-toggle="tooltip" title="InActive" v-if="row.item.zonestatus == '0'" style="cursor:pointer">
                                  <span class="badge badge-danger" @click="editactiveinactive(row.item.zoneid, row.item.zonestatus);">Inative</span>
                              </span>
                              <span data-toggle="tooltip" title="Active" v-if="row.item.zonestatus == '1'"  style="cursor:pointer">
                                  <span class="badge badge-success" @click="editactiveinactive(row.item.zoneid, row.item.zonestatus);">Active</span>
                              </span>
                            </template>
                          <template slot="Action" slot-scope="row">
                            <div>
                                <input
                                  @change="setStickerHTMl($event, row.item)"
                                  type="radio"
                                  :disabled="(isReadOnly || row.item.zonestatus == '0')"
                                  name="radAnswer"
                                  v-model="row.item.selected"
                                  class="shipmentscheckbox"
                                  id="stiker"
                                  :checked="checkedData"
                                />&nbsp;
                                <b-button :disabled="(isReadOnly || row.item.zonestatus == '0')"
                                  id="printbuttons"
                                  variant="primary"
                                  size="sm"
                                  value="print a div!"
                                 
                                  @click="barcodedata('printableArea', row.item)"
                                  style="background: #b0c4de !important;color: #000 !important;"
                                  >Print Zone
                                </b-button>&nbsp;
                                <b-button size="sm"  v-if="User_type == 2 && route_id=='normal' && isReadOnly==false" @click="editLBHModal(row.item,'edit')"
                                data-toggle="tooltip" title="Edit Zone Details">
                                 <i class="fa fa-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                            <br>
                          </template>
                          <template slot="Edit" slot-scope="row"  v-if="User_type == 1">
                            <div>
                              <b-button :disabled="isReadOnly" 
                                size="sm"
                                @click="editzoneModal(row.item,'edit')"
                                data-toggle="tooltip"
                                title="Edit Zone Details"
                              >
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                              </b-button>&nbsp;
                              <b-button
                              size="sm"
                              @click="LogDetailsModal(row.item)"
                              data-toggle="tooltip"
                              title="Log Details"
                            >
                            <i class="fa fa-history" aria-hidden="true"></i>
                            </b-button>
                          </div>
                          </template>
                          
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
  
            <div v-else>
              <b-row>
                <b-col sm="12" class="text-center">
                  <span>No Records Found</span>
                </b-col>
              </b-row>
            </div>
          </div>

          <div v-else>
            <b-row>
              <b-col sm="12" class="text-right  " >
                  <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> 
                 <!-- {{User_type}} -->
                </b-col>
              <b-col md="12">
                <b-table
                  show-empty
                  responsive
                  :items="zonelist"
                  :busy="isBusy"
                  :current-page="currentPage"
                  :fields="fieldsasn"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :bordered="bordered" 
                >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="zone_city" slot-scope="row">
                    <div>
                      <b-button
                        size="sm"
                        @click="viewcityModal(row.item)"
                        data-toggle="tooltip"
                        title="View City Details"
                      >
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </b-button>&nbsp;
                    </div>
                  </template>
                  <template slot="zone_status" slot-scope="row">

                    <span data-toggle="tooltip" title="InActive" v-if="row.item.zonestatus == '0'" style="cursor:pointer;">
                        <span class="badge badge-danger" @click="editactiveinactive(row.item.zoneid, row.item.zonestatus);">Inative</span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-if="row.item.zonestatus == '1'" style="cursor:pointer;">
                        <span class="badge badge-success" @click="editactiveinactive(row.item.zoneid, row.item.zonestatus);">Active</span>
                    </span>
                  </template>
                  <!--  -->
                  <template slot="Action" slot-scope="row">
                    <div>
                        <input :disabled="(isReadOnly || row.item.zonestatus == '0')"
                          @change="setStickerHTMl($event, row.item)"
                          type="radio"
                          name="radAnswer"
                          v-model="row.item.selected"
                          class="shipmentscheckbox"
                          id="stiker"
                          :checked="checkedData"
                        />&nbsp;
                        <b-button :disabled="(isReadOnly || row.item.zonestatus == '0')" 
                          id="printbuttons"
                          variant="primary"
                          size="sm"
                          value="print a div!"
                          @click="barcodedata('printableArea', row.item)"
                          style="background: #b0c4de !important;color: #000 !important;"
                          >Print Zone
                        </b-button>&nbsp;
                        <b-button size="sm"  v-if="User_type == 2 && route_id=='normal' && isReadOnly==false" @click="editLBHModal(row.item,'edit')"
                        data-toggle="tooltip" title="Edit Zone Details">
                         <i class="fa fa-pencil" aria-hidden="true"></i>
                      </b-button>
                    </div>
                    <br>
                  </template>
                  <template slot="Edit" slot-scope="row"  v-if="User_type == 1">
                    <div>
                      <b-button :disabled="isReadOnly"
                        size="sm"
                        @click="editzoneModal(row.item,'edit')"
                        data-toggle="tooltip"
                        title="Edit Zone Details"
                      >
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </b-button>&nbsp;
                      <b-button
                      size="sm"
                      @click="LogDetailsModal(row.item)"
                      data-toggle="tooltip"
                      title="Log Details"
                    >
                    <i class="fa fa-history" aria-hidden="true"></i>
                    </b-button>
                  </div>
                  </template>
                  
                </b-table>
              </b-col>
            </b-row>
          </div>

          <!-- // start map city modal -->
          <b-modal title="View Map City" v-model="mapcitymodel" @ok="mapcitymodel=false" size="lg" hide-footer>
            <b-table
            show-empty
            responsive
            :items="mapcityoptions"
            :busy="isBusycity"
            :current-page="currentPage"
            :fields="fieldcity"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :bordered="bordered" 
          >
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
            </b-table>
          </b-modal>
          <!-- // end map city modal -->
          <!-- // start edit model -->
          <b-modal title="Edit Zone Details" v-model="editmodel"  @ok="editmodel = false"  size="xl" hide-footer>
            <b-card>
              <div id="overlaymodel" >
                <div class="modelloader"></div>
              </div>
              <b-form
                @submit.prevent="validateForm2('form-3')"
                data-vv-scope="form-3"
              >
                <b-col md="12">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <b-row>
                          <b-col :sm="route_id=='normal'? 3 : 4">
                            <strong>{{ route_id=='normal'?'Zone Name' :'Vendor Zone Name' }}</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                          </b-col>
                          <b-col :sm="route_id=='normal'? 9 : 8">
                            <b-form-input
                            class="input"
                            type="text"
                            v-model="zonecustomer.zone_name"
                            name="Zone_name"
                            v-validate="'required|alpha_spaces'"
                            :class="{
                              input: true,
                              'text-invalid': errors.has('form-3.Zone_name'),
                            }"
                            placeholder="Enter Zone Name"
                          >
                          </b-form-input>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-3.Zone_name')"
                                >{{ errors.first("form-3.Zone_name") }}</i
                              >
                            </span>
                          </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <b-row>
                          <b-col :sm="route_id== 'normal' ? 4 : 5">
                            <strong>{{ route_id=='normal'?'Zone Number':'Vendor Zone Number' }}</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                          </b-col>
                          <b-col :sm="route_id== 'normal' ? 8 : 7">
                            <b-form-input
                          class="input"
                          type="text"
                          v-model="zonecustomer.zone_number"
                          name="Zone_number"
                          v-validate="'required|regex:^[A-Za-z0-9-]+$'"
                          :class="{
                            input: true,
                            'text-invalid': errors.has('form-3.Zone_number'),
                          }"
                          placeholder="Enter Zone Number"
                        >
                        </b-form-input>
                        <b-input-group class="mt-2">
                          <span class="icon has-text-warning">
                            <i
                              class="fa fa-warning help text-danger"
                              v-show="errors.has('form-3.Zone_number')"
                              >{{ errors.first("form-3.Zone_number") }}</i
                            >
                          </span>
                        </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <b-row>
                          <b-col sm="3">
                            <strong for="Select Type">Select Type</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                          </b-col>
                          <b-col sm="9">
                            <b-form-radio-group disabled
                              v-model="zonecustomer.zone_selecttype"
                              :options="options"
                              class="mt-2"
                              value-field="item"
                              text-field="name"
                              disabled-field="notEnabled"
                              name="Zone_check"
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'text-invalid': errors.has('form-3.Zone_check'),
                              }"
                            >
                            </b-form-radio-group>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-3.Zone_check')"
                                  >{{ errors.first("form-3.Zone_check") }}</i
                                >
                              </span>
                            </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6" v-if="route_id=='asn'">
                      <b-form-radio-group disabled
                          v-model="zonecustomer.zone_for"
                          :options="huboptions"
                          class="mt-2 selectbutton"
                          value-field="item"
                          text-field="name"
                          disabled-field="notEnabled"
                          name="vendor_Zone_check"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'text-invalid': errors.has('form-3.vendor_Zone_check'),
                          }"
                        >
                      </b-form-radio-group>
                      <b-input-group class="mt-2">
                          <span class="icon has-text-warning">
                            <i
                              class="fa fa-warning help text-danger"
                              v-show="errors.has('form-3.vendor_Zone_check')"
                              >{{ errors.first("form-3.vendor_Zone_check") }}</i
                            >
                          </span>
                      </b-input-group>
                    </b-col>

                    <b-col sm="6"  class="mt-4">
                        <div v-if="zonecustomer.zone_selecttype == 'Dock'">
                          <b-form-group>
                            <b-row>
                              <b-col sm="4">
                                <strong for="Map Zone To City">Map Zone To City</strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                              </b-col>
                              <b-col sm="8">
                                <div id='container'>
                                  <ejs-multiselect
                                  id="multiselect" placeholder="Please Select City" v-model="zonecustomer.zone_mapcity" :dataSource='optionsWH' :fields='fieldWH' 
                                  @change="changeWarehouse(zonecustomer.zone_mapcity)"></ejs-multiselect>
                                </div> 
                              </b-col>
                            </b-row>
                          </b-form-group>
                        </div>

                        <div v-else>
                          <b-form-group>
                            <b-row>
                              <b-col sm="4">
                                <strong>Map Zone To City </strong>&nbsp;<span style="color: red;">*</span><b>&nbsp;:</b>
                              </b-col>
                              <b-col sm="8">
                                <div id='container'>
                                  <ejs-multiselect
                                  id="multiselect" placeholder="Please Select City" v-model="zonecustomer.zone_mapcity" :dataSource='optionsWH' :fields='fieldWH' 
                                  @change="changeWarehouse(zonecustomer.zone_mapcity)"
                                  name="Select_City"
                                  v-validate="'required'"
                                  :class="{
                                    input: true,
                                    'text-invalid': errors.has('form-3.Select_City'),
                                  }" ></ejs-multiselect>
                                </div>
                              </b-col>
                            </b-row> 
                          </b-form-group>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-3.Select_City')"
                                >{{ errors.first("form-3.Select_City") }}</i
                              >
                            </span>
                          </b-input-group>
                        </div>
                    </b-col>
                  </b-row>
                </b-col>

                <footer class="column has-text-right">
                  <div>
                    <b-button
                    variant="primary"
                    size="md"
                    type="submit"
                    style="float: right;"
                    >Edit</b-button
                  >
                  </div>
                </footer>
              </b-form>
            </b-card>
          </b-modal>
          <!-- // end edit model -->

           <!-- // start Log model -->
          <b-modal title="Log Details" v-model="logdetailsModal" @ok="logdetailsModal=false" size="xl" hide-footer>
            <div class="logmodel">
              <table>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th>Updated Zone Name</th>
                  <th>City</th>
                  <th>Updated City</th>
                  <th>Updated By</th>
                  <th>Updated Date</th>
                </tr>
                
                <tr v-for="zonelog in zonelogDetails" :key="zonelog.zoneid">
                  <!-- {{ zonelog }} -->
                  <td v-if="zonelog.updated_field=='zone title'">{{zonelog.zoneid}}</td>
                  <td v-if="zonelog.updated_field=='zone title'">{{zonelog.previous_value}}</td>
                  <td v-if="zonelog.updated_field=='zone title'">{{zonelog.updated_value}}</td>
                  <td v-if="zonelog.updated_field=='zone title'"></td>
                  <td v-if="zonelog.updated_field=='zone title'"></td>
                  <td v-if="zonelog.updated_field=='zone title'">{{zonelog.updated_by}}</td>
                  <td v-if="zonelog.updated_field=='zone title'">{{zonelog.updated_date}}</td>



                  <td v-if="zonelog.updated_field=='zone city'">{{zonelog.zoneid}}</td>
                  <td v-if="zonelog.updated_field=='zone city'"></td>
                  <td v-if="zonelog.updated_field=='zone city'"></td>
                  <td v-if="zonelog.updated_field=='zone city'">{{zonelog.previous_value}}</td>
                  <td v-if="zonelog.updated_field=='zone city'">{{zonelog.updated_value}}</td>
                  <td v-if="zonelog.updated_field=='zone city'">{{zonelog.updated_by}}</td>
                  <td v-if="zonelog.updated_field=='zone city'">{{zonelog.updated_date}}</td>
                </tr>
                <tr v-if="totallogcount==0" style="border: 1px solid #e7e1e1;">
                  <br><br><br>
                  <span style="position: absolute;
                  right: 50%;
                  bottom: 60px;"><b>No Records Found</b></span>
                </tr>
              </table>
            </div>
          </b-modal>
           <!-- // end Log model -->

          <div id="printableArea">
            <div class="page-break" v-for="zone in zoneArr">
              <div style="font-size: 25px;">
                <b>{{ zone.zone_title }} -- {{zone.zone_no}}</b>
              </div>
              <!-- <br> -->
              <br />
              <qr-code :text="zone.zone_id"></qr-code>
            </div>
          </div>

          <!-- Pallet -->
          <div>
            <b-modal
              id="modal-1"
              title="Add Pallet"
              size="xl"
              v-model="showpalletdetails"
              @ok="showpalletdetails = false"
              hide-footer
            >
              <b-row>
                <b-col v-if="User_type == 2" style="display: block;">
                  <b-button :disabled="isReadOnly"
                    size="sm"
                    class="btn btn-sm btn-primary mr-4"
                    style="float: right; margin: 0px 0px 15px 0px;"
                    data-toggle="tooltip"
                    variant="primary"
                    @click="addZonePallet()"
                    >Add Pallet</b-button
                  >
                </b-col>
              </b-row>

              <div>
                <b-collapse id="Pallet">
                  <b-card>
                    <b-form
                      @submit.prevent="validateForm1('form-2')"
                      data-vv-scope="form-2"
                    >
                      <b-col md="12">
                        <b-row>
                          <b-col sm="6">
                            <b-form-group label="Pallet Name :" :label-cols="3">
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Users.pallet_name"
                                name="Pallet_name"
                                v-validate="'required|alpha_spaces'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has(
                                    'form-2.Pallet_name'
                                  ),
                                }"
                                placeholder="Enter Pallet Name"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-2.Pallet_name')"
                                    >{{ errors.first("form-2.Pallet_name") }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col sm="6">
                            <b-form-group
                              label="Pallet Number :"
                              :label-cols="3"
                            >
                              <b-form-input
                                class="input"
                                type="text"
                                v-model="Users.pallet_number"
                                name="Pallet_number"
                                v-validate="'required|numeric'"
                                :class="{
                                  input: true,
                                  'text-invalid': errors.has(
                                    'form-2.Pallet_number'
                                  ),
                                }"
                                placeholder="Enter Pallet Number"
                              >
                              </b-form-input>
                              <b-input-group class="mt-2">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-2.Pallet_number')"
                                    >{{
                                      errors.first("form-2.Pallet_number")
                                    }}</i
                                  >
                                </span>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>

                      <footer class="column has-text-right">
                        <b-button
                          variant="primary"
                          size="md"
                          type="submit"
                          style="float: right;"
                          >ADD</b-button
                        >
                      </footer>
                      <div id="overlayModal">
                  <div class="loaderModal"></div>
                </div>
                    </b-form>
                  </b-card>
                </b-collapse>
              </div>

              <b-row>
                <b-col sm="12" class="text-right  " >
                <b>Total Records :<span style="color:red;">{{ pallettotalRows }}</span></b> 
                 </b-col>
                <b-col md="12">
                  <b-table
                    show-empty responsive :items="palletlist"
                    :busy="isBusypallet" :current-page="currentPagePallet"
                    :fields="fieldsPallet" :per-page="perPagePallet"
                    :filter="filter" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                    :bordered="bordered">
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                    <template slot="Action" slot-scope="row">
                      <input :disabled="isReadOnly"
                        @change="setpalletStickerHTMl($event, row.item)"
                        type="radio"
                        name="radAnswer"
                        v-model="row.item.selected"
                        class="shipmentscheckbox"
                        id="stiker"
                        :checked="checkedpalletData"
                      />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                      <b-button :disabled="isReadOnly"
                        id="printbutton"
                        variant="primary"
                        size="sm"
                        value="print a div!"
                        @click="
                          barcodepalletdata('printablePalletArea', row.item)
                        "
                        style="background: #b0c4de !important;color: #000 !important;"
                        >Print Pallet </b-button
                      >&nbsp;&nbsp;
                    </template>
                  </b-table>
                </b-col>
              </b-row>

              <div id="printablePalletArea">
                <div class="page-break" v-for="pallet in palletArr">
                  <div style="font-size: 25px;">
                    <b>{{ pallet.pallet_title }}</b>
                  </div>
                  <!-- <br> -->
                  <br />
                  <qr-code :text="pallet.pallet_id"></qr-code>
                </div>
              </div>
            </b-modal>
            
          </div>
          <!-- END Pallet -->
          <b-modal title="Edit Zone Details" v-model="editLBH"  @ok="editLBH = false"  size="xl" hide-footer>
            <b-card>
              <div id="overlaymodel" >
                <div class="modelloader"></div>
              </div>
              <b-form
                @submit.prevent="validateForm3('form-3')"
                data-vv-scope="form-3"
              >
                <b-col md="12">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="Select Type :" :label-cols="3">
                        <b-form-radio-group 
                          v-model="Customer.selectedredio"
                          :options="options"
                          class="mt-2"
                          value-field="item"
                          text-field="name"
                          disabled-field="notEnabled"
                          name="Zone_check"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'text-invalid': errors.has('form-3.Zone_check'),
                          }"
                        >
                        </b-form-radio-group>
                        <b-input-group class="mt-2">
                          <span class="icon has-text-warning">
                            <i
                              class="fa fa-warning help text-danger"
                              v-show="errors.has('form-3.Zone_check')"
                              >{{ errors.first("form-3.Zone_check") }}</i
                            >
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group label="Length (in Feet):" :label-cols="3">
                          <b-form-input
                            class="input"
                            type="text"
                            v-model="Customer.length"
                            name="length"
                            v-validate="'required|decimal:3'"
                            :class="{
                              input: true,
                              'text-invalid': errors.has('form-3.length'),
                            }"
                            placeholder="Enter Box Length"
                          >
                          </b-form-input>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-3.length')"
                                >{{ errors.first("form-3.length") }}</i
                              >
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group label="Breadth (in Feet):" :label-cols="3">
                          <b-form-input
                            class="input"
                            type="text"
                            v-model="Customer.breadth"
                            name="breadth"
                            v-validate="'required|decimal:3'"
                            :class="{
                              input: true,
                              'text-invalid': errors.has('form-3.breadth'),
                            }"
                            placeholder="Enter Box Breadth"
                          >
                          </b-form-input>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-3.breadth')"
                                >{{ errors.first("form-3.breadth") }}</i
                              >
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6" v-if="route_id=='normal'">
                        <b-form-group label="Height (in Feet):" :label-cols="3">
                          <b-form-input
                            class="input"
                            type="text"
                            v-model="Customer.height"
                            name="height"
                            v-validate="'required|decimal:3'"
                            :class="{
                              input: true,
                              'text-invalid': errors.has('form-3.height'),
                            }"
                            placeholder="Enter Box Height"
                          >
                          </b-form-input>
                          <b-input-group class="mt-2">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-3.height')"
                                >{{ errors.first("form-3.height") }}</i
                              >
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                  </b-row>
                </b-col>

                <footer class="column has-text-right">
                  <div>
                    <b-button variant="primary" size="md" type="submit"
                    style="float: right;">Edit</b-button
                  >
                  </div>
                </footer>
              </b-form>
            </b-card>
          </b-modal>


           <b-modal title="Edit Zone Details" v-model="editactiveinactivezone"  @ok="editactiveinactivezone = false"  size="lg" hide-footer>
            <b-card>
              <div id="overlaymodel" >
                <div class="modelloader"></div>
              </div>
              <b-form
                @submit.prevent="validateForm4('form-4')"
                data-vv-scope="form-4"
              >
                <b-col md="12">
                  <b-row>
                      <b-col sm="12" v-if="route_id=='normal'">
                      <b-row v-if="route_id == 'normal'">
                        <b-col sm="4">
                            <p><strong>Zone Id :</strong> {{ selected_zone_id }}</p>
                        </b-col>

                        <b-col sm="6">
                            <p>
                                <strong>Zone Status : </strong>
                                <span :class="selected_zone_status == 1 ? 'badge badge-success' : 'badge badge-danger'">
                                    {{ selected_zone_status == 1 ? 'Active' : 'Inactive' }}
                                </span>
                            </p>
                        </b-col>
                    </b-row>
                      </b-col>
                      <b-col sm="12" v-if="route_id=='normal'">
                          <b-form-group label="Zone Status:" :label-cols="3">
                            <b-form-select
                              v-model="Customer.zonestatus"
                              name="zonestatus"
                              v-validate="'required'"
                              :options=statusOptions
                              :class="{
                                input: true,
                                'text-invalid': errors.has('form-4.zonestatus')
                              }"
                            >
                              <template #first>
                                <b-form-select-option :value="null">
                                  Select Zone Status
                                </b-form-select-option>
                              </template>
                            </b-form-select>

                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-4.zonestatus')"
                                >
                                  {{ errors.first("form-4.zonestatus") }}
                                </i>
                              </span>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                    
                  </b-row>
                </b-col>

                <footer class="column has-text-right">
                  <div>
                    <b-button variant="primary" size="md" type="submit"
                    style="float: right;">Submit</b-button
                  >
                  </div>
                </footer>
              </b-form>
            </b-card>
          </b-modal>
          <div id="overlay" >
            <div class="loader"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      addNewZone: false,
      Customer: {
        selected_mapcity:[],
        is_rto_zone: 'no',
        zonestatus: null
      },
      zonelist: [],
      fieldsnormal: [
        { key: "zoneid", label: "Zone Id", sortable: true },
        { key: "zone_title", label: "Zone Name", sortable: true },
        { key: "zone_no", label: "Zone Number", sortable: true },
        { key: "zonetype", label: "Zone Type", sortable: true },
        { key: "is_rto_zone", label: "Is RTO Zone", sortable: true },
        { key: "created_date", label: "Created Date", sortable: true },
        { key: "created_by", label: "Created By", sortable: true },
        { key: "Action", label: "Action", sortable: true },
      ],
      fieldsasn:[],
      isBusy: false,
      qrdetail: [],
      QRcodezone_id: "",
      QRcodezone_title: "",
      checkedData: false,
      zoneArr: [],
      selected_zone_id: "",
      QrcodeVue,
      // selectedredio : '',
      options: [
        { item: "Dock", name: "Dock" },
        { item: "Normal", name: "Normal" },
      ],
      huboptions: [
          { item: "is_vendor", name: "Is Vendor Hub" },
          { item: "is_b2c", name: "Is B2C Zone" },
        ],
        // selected_mapcity:'',
      mapoptions: [],
      Users: {},
      isBusypallet:false,
      palletlist: [],
      fieldsPallet: [
        { key: "pallet_id", label: "Pallet Id", sortable: true },
        { key: "pallet_title", label: "Pallet Name", sortable: true },
        { key: "pallet_no", label: "Pallet Number", sortable: true },
        { key: "created_date", label: "Created Date", sortable: true },
        { key: "created_by", label: "Created By", sortable: true },
        { key: "Action", label: "Action", sortable: true },
      ],
      selectedpalletdata: [],
      showpalletdetails: false,
      checkedpalletData: false,
      palletArr: [],
      selected_pallet_id: "",
      zone_type: "",
      User_type: "",
      totalRows:0,
      pallettotalRows:0,
      route_id :null,
      // valueWH:[],
      fieldWH:{ text: 'name', value: 'id' },
      optionsWH:[],
      WHData:[],
      showSelectAll : true,
      editmodel : false,
      zonecustomer : {
        zone_mapcity :[],
      },
      logdetailsModal : false,
      mapcitymodel : false,
      mapcityoptions : [],
      fieldcity : [
        { key: "zoneid", label: "Zone Id", sortable: true },
        { key: "zone_title", label: "Zone Name", sortable: true },
        { key: "city_name", label: "Zone City", sortable: true },
      ],
      isBusycity : false,
      editzonid : '',
      editmapcityvalue : [],
      zonecity : '',
      mapcityselected : [],
      zonelogDetails : [],
      totallogcount : 0,
      editsysusermasterid : '',
      edithub_id : '',
      action_type:'',
      editLBH:false,
      hubCount :[],
      hubcount_length :0,
      isLoading : false,
      accessBody:[],
      isReadOnly:false,
      editactiveinactivezone: false,
      selected_zone_status:'',
      statusOptions: [
            { value: null, text: 'Select Status', disabled: true },
            { value: '1', text: 'Active' },
            { value: '0', text: 'Inactive' }
    ],
    selected_hubid:'',
    };
  },
  components: {
    QrcodeVue,
  },
  created() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.User_type = userInfo.user_type;
    this.route_id = this.$route.params.id;
    if ( this.User_type ==1) {
      this.hubDashboardcount();
    }
    else{
      this.ZoneListings();
    }
    this.accessBody = userInfo.body;
    this.ischeckbodyvalidation();
  },

beforeUpdate(){
  // console.log("beforeUpdate----->",this.$route)
},

  methods: {
   validateZone() {
    this.Customer.zone_number = this.Customer.zone_number.replace(/[^A-Za-z0-9-]/g, '');
  },
    ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Zone Management' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                console.log("--------------",k.title,k.isReadonly,this.route_id)
                  if (k.title=='Zone Management' && k.isReadonly==true && this.route_id=='normal') {
                      this.isReadOnly=true
                  }
                  if (k.title=='Zone Management' && k.isReadonly==true && this.route_id=='asn') {
                    this.isReadOnly=true
                  } 
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
    getCityList(type,value){
      console.log('Value@@@@@@@@@@@',value);
      if(value==='is_vendor'){
        this.action_type=type;
      this.citylist();
      }
      
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addZoneForm();
        }
      });
    },

    addZoneForm: function() {
      // alert("ok")
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      if (this.route_id=='normal') {
        this.zoneObj = {
          creatersysusermasterid: `${userInfo.sysusermasterid}`,
          zonetitle: `${this.Customer.zone_name}`,
          zoneno: `${this.Customer.zone_number}`,
          createdby:`${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
          zonetype: `${this.Customer.selectedredio}`,
          hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
          length:this.Customer.length,
          breadth:this.Customer.breadth,
          height:this.Customer.height,
          is_asn:'NO',
          is_rto_zone: this.Customer.is_rto_zone // <-- send RTO value
        };
      } else {
        this.zoneObj = {
          creatersysusermasterid: `${userInfo.sysusermasterid}`,
          zonetitle: `${this.Customer.zone_name}`,
          zoneno: `${this.Customer.zone_number}`,
          createdby:
            `${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
          zonetype: `${this.Customer.selectedredio}`,
          hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
          is_asn:'YES',
          zone_city:this.Customer.selected_mapcity,
          zone_for:`${this.Customer.zone_for}`,
          is_rto_zone: this.Customer.is_rto_zone // <-- send RTO value
        };
      }
      console.log("zoneObj", this.zoneObj);
      // return false;
      // if (this.getPincodes.length !=0) {
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/createNewZone`,this.zoneObj)
        .then((result) => {
          // alert("Api")
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Added Successfully",
              type: "success",
              timer: 30000,
            });
            this.ZoneListings();
            this.Customer = {};
            this.Customer.selected_mapcity =[];
            this.errors.clear("form-1");
            document.getElementById("Zone").style.display = "none";
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
      // }else{
      //     this.$fire({
      //                 text:"Please Enter Valid PinCode ",
      //                 type: "error",
      //                 timer: 30000
      //             });
      // }
    },

    ZoneListings: function(value) {
      this.selected_hubid= value
      this.isBusy = true;
      this.isLoading=true;
      let userdata = localStorage.getItem("userData");
      let userInfo = JSON.parse(userdata);

      if (this.route_id == 'asn' && this.User_type==1) {
        this.fieldsasn= [
          { key: "zoneid", label: "Zone Id", sortable: true },
          { key: "zone_title", label: "Zone Name", sortable: true },
          { key: "zone_no", label: "Zone Number", sortable: true },
          { key: "zonetype", label: "Zone Type", sortable: true },
          { key: "is_rto_zone", label: "Is RTO Zone", sortable: true },
          { key: "zone_for", label: "Zone For", sortable: true },
          { key: "created_date", label: "Created Date", sortable: true },
          { key: "created_by", label: "Created By", sortable: true },
          { key: "zone_city", label: "Zone City", sortable: true },
          { key: "Action", label: "Action", sortable: true },
          { key: "Edit", label: "Edit/Log Details", sortable:true },
        ];
      }
      else if(this.route_id == 'asn'){
        this.fieldsasn= [
          { key: "zoneid", label: "Zone Id", sortable: true },
          { key: "zone_title", label: "Zone Name", sortable: true },
          { key: "zone_no", label: "Zone Number", sortable: true },
          { key: "zonetype", label: "Zone Type", sortable: true },
          { key: "is_rto_zone", label: "Is RTO Zone", sortable: true },
          { key: "zone_for", label: "Zone For", sortable: true },
          { key: "created_date", label: "Created Date", sortable: true },
          { key: "created_by", label: "Created By", sortable: true },
          { key: "zone_city", label: "Zone City", sortable: true },
          { key: "Action", label: "Action", sortable: true },
        ];
      }
      else{
        this.fieldsasn= [
          { key: "zoneid", label: "Zone Id", sortable: true },
        { key: "zone_title", label: "Zone Name", sortable: true },
        { key: "zone_no", label: "Zone Number", sortable: true },
        { key: "zonetype", label: "Zone Type", sortable: true },
        { key: "is_rto_zone", label: "Is RTO Zone", sortable: true },
        { key: "lastmodifiedby", label: "Last Modified By", sortable: true ,
          formatter: value => value ? value : '-',
        },
        { key: "lastmodifieddate", label: "Last Modified Date and Time ", sortable: true,
          formatter: value => value ? value : '-',
        },
        { key: "zone_status", label: "Zone Status", sortable: true
        },
        { key: "is_rto_zone", label: "Is RTO Zone", sortable: true },
        { key: "created_date", label: "Created Date", sortable: true },
        { key: "created_by", label: "Created By", sortable: true },
        { key: "Action", label: "Action", sortable: true },
        ];
      }
      
      const obj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        is_asn: this.route_id == 'normal' ? 'NO': 'YES',
        hub_id:`${userInfo.user_type == 1 ?value:userInfo.hub_id}`
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getAdminZoneListing`, obj)
        .then((result) => {
          this.isBusy = false;
          this.isLoading=false;

          if (result.body.returnmsg === "Successful") {
            this.zonelist = result.body.returnvalue;    
            this.totalRows = result.body.returnvalue.length;
          } else {
            this.zonelist = [];
            this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    barcodedata(printableArea, value) {
      if (this.checkedData == true && this.selected_zone_id == value.zoneid) {
        var printContents = document.getElementById("printableArea").innerHTML;
        // alert(printContents)
        var disp_setting = "toolbar=yes,location=no,";
        disp_setting += "directories=yes,menubar=yes,";
        disp_setting +=
          "scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = printContents;
        var docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
        );
        docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
        );
        docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
        );
        docprint.document.write("<head>");
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write("font-family:verdana,Arial;color:#000;");
        docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
        );
        docprint.document.write("a{color:#000;text-decoration:none;} ");
        docprint.document.write(
          ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
        );
        docprint.document.write(
          ".printarea{ font-size: 30px;text-align: center;}"
        );

        docprint.document.write(".addpad{ padding: 10px; }");
        docprint.document.write(
          "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
        );
        docprint.document.write(
          "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
        );
        docprint.document.write(".stickertable td{ padding-bottom:10px;  }");
        docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");
        docprint.document.write('</head><body onLoad="self.print()"><center>');
        docprint.document.write(content_vlue);
        docprint.document.write("</center></body></html>");
        docprint.document.close();
      } else {
        this.$fire({
          text: "Please Select Check Box",
          type: "warning",
          timer: 30000,
        });
      }
    },

    setStickerHTMl(e, value) {
      // console.log("ggggg",value)
      this.zoneArr = [];
      this.checkedData = true;
      this.selected_zone_id = value.zoneid;
      // console.log("Valueeeeeeeeeeeeeeee", this.selected_zone_id);
      const obj = {
        zone_id: `${value.zoneid}`,
        zone_title: value.zone_title,
        zone_no: value.zone_no,
      };
      this.zoneArr.push(obj);
      console.log("Titlwwwwww", this.zoneArr);
    },

    //pallet start
    addZonePallet() {
      // alert("ok")
      document.getElementById("Pallet").style.display = "block";
    },

    validateForm1(scope) {
      // alert("ok")
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addPalletForm();
        }
      });
    },

    addPalletForm: function() {
      document.getElementById("overlayModal").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const PalletObj = {
        creatersysusermasterid: `${userInfo.sysusermasterid}`,
        pallettitle: `${this.Users.pallet_name}`,
        palletno: `${this.Users.pallet_number}`,
        createdby:
          `${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
        zoneid: `${this.selected_palletzone_id}`,
        hub_id : `${userInfo.hub_id}`,
      };
      console.log("PalletObj", PalletObj);
      // return false;
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/createNewPallet`, PalletObj)
        .then((result) => {
          // alert("Api")
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Added Successfully",
              type: "success",
              timer: 30000,
            });
            this.PalletListing();
            this.Users = {};
            this.errors.clear("form-2");
            document.getElementById("Pallet").style.display = "none";
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    Openpallet: function(data) {
      // alert("o")
      console.log("data", data);
      this.selectedpalletdata = data;
      this.selected_palletzone_id = data.zoneid;
    //   console.log("selected_palletzone_id", this.selected_palletzone_id);
      this.PalletListing();
      this.showpalletdetails = true;
    },

    PalletListing: function() {
      this.isBusypallet = true;
      let userdata = localStorage.getItem("userData");
      let userInfo = JSON.parse(userdata);
      const obj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        zoneid: `${this.selected_palletzone_id}`,
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getPalletListing`, obj)
        .then((result) => {
          this.isBusypallet = false;
          console.log("result", result);
          if (result.body.returnmsg === "Successful") {
            // alert("ok")
            this.palletlist = result.body.returnvalue;
            // console.log("palletlist", this.palletlist);
            this.pallettotalRows = result.body.returnvalue.length;
          } else {
            this.palletlist = [];
            this.pallettotalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    barcodepalletdata(printablePalletArea, value) {
      console.log("value",value)
      console.log("this.selected_pallet_id",this.selected_pallet_id)
      if (
        this.checkedpalletData == true &&
        this.selected_pallet_id == value.pallet_id
      ) {
        var printContents = document.getElementById("printablePalletArea")
          .innerHTML;
        // alert(printContents)
        var disp_setting = "toolbar=yes,location=no,";
        disp_setting += "directories=yes,menubar=yes,";
        disp_setting +=
          "scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = printContents;
        var docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
        );
        docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
        );
        docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
        );
        docprint.document.write("<head>");
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write("font-family:verdana,Arial;color:#000;");
        docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
        );
        docprint.document.write("a{color:#000;text-decoration:none;} ");
        docprint.document.write(
          ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
        );
        docprint.document.write(
          ".printarea{ font-size: 30px;text-align: center;}"
        );

        docprint.document.write(".addpad{ padding: 10px; }");
        docprint.document.write(
          "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
        );
        docprint.document.write(
          "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
        );
        docprint.document.write(".stickertable td{ padding-bottom:10px;  }");
        docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");
        docprint.document.write('</head><body onLoad="self.print()"><center>');
        docprint.document.write(content_vlue);
        docprint.document.write("</center></body></html>");
        docprint.document.close();
      } else {
        this.$fire({
          text: "Please Select Check Box",
          type: "warning",
          timer: 30000,
        });
      }
    },

    setpalletStickerHTMl(e, value) {
      console.log(value)
      this.palletArr = [];
      this.checkedpalletData = true;
      this.selected_pallet_id = value.pallet_id;
      // console.log("Valueeeeeeeeeeeeeeee", this.selected_zone_id);
      const obj = {
        pallet_id: `${value.pallet_id}`,
        pallet_title: value.pallet_title,
      };
      this.palletArr.push(obj);
      console.log("TitlwwwwwwpalletArr", this.palletArr);
    },


    //ASN

    citylist: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj = {
        hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : this.edithub_id,
        type:this.action_type
      };
      console.log("Obj", Obj);
      // return false;
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/mapZoneToCityList`,Obj)
        .then((result) => {
          console.log("list",result)
          if (result.body.returnmsg === "Successful") {
            // this.mapoptions = result.body.returnvalue;
            this.optionsWH=[];
            this.WHData  = result.body.returnvalue;
            
            for(let j = 0; j < this.WHData.length; j++) {
                let WH = {
                  name: this.WHData[j].sourcecity,
                  id: this.WHData[j].sourcecity,
                }
              this.optionsWH.push(WH);
              this.editmapcityvalue.push(WH.name);
              this.changeWarehouse(this.editmapcityvalue);

            }
          } else {
            // this.mapoptions = [];
            this.WHData  = result.body.returnvalue;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    viewcityModal : function(value){
      console.log("value",value)
      this.mapcityoptions = [];
      this.mapcitymodel = !this.mapcitymodel;
      this.isBusycity = true;
      const Obj= {
        zoneid: value.zoneid
      }
      console.log(Obj)

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/zoneWiseMapCityList`,Obj)
        .then((result) => {
          console.log("list",result)
          this.isBusycity = false;
          if (result.body.returnmsg === "Successful") {
            this.mapcityoptions = result.body.returnvalue;
            console.log("mapcityoptions",this.mapcityoptions)
          } else {
            this.mapcityoptions = result.body.returnvalue;;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    editzoneModal : function(value,type){
      console.log(value)
      this.action_type=type;
      this.zonecustomer = {
        zone_mapcity :[],
      };
      
      this.editmodel= !this.editmodel;
      // this.zone_mapcity.push(value.zone_city);
      this.editzonid = value.zoneid;
      this.editsysusermasterid = value.creater_sysusermasterid;
      this.edithub_id = value.hub_id;
      this.zonecustomer.zone_name = value.zone_title;
      this.zonecustomer.zone_number = value.zone_no;
      this.zonecustomer.zone_selecttype = value.zonetype;
      this.zonecustomer.zone_for = value.zone_for;
      this.citylist();
      console.log(value.zone_city)

      const Obj= {
        zoneid: value.zoneid,

      }
      console.log(Obj)

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/zoneWiseMapCityList`,Obj)
        .then((result) => {
          console.log("list",result)
          this.isBusycity = false;
          if (result.body.returnmsg === "Successful") {
            this.mapcityselected = result.body.returnvalue;
            console.log("mapcityoptions",this.mapcityselected)
            for (let i = 0; i < this.mapcityselected.length; i++) {
              this.zonecity = this.mapcityselected[i].city_name;
              console.log("zonecity",this.zonecity)
              this.zonecustomer.zone_mapcity.push(this.zonecity);
            }
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@",this.zonecustomer.zone_mapcity)
          } else {
            this.mapcityselected = result.body.returnvalue;;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    changeWarehouse: function(value) {
      // alert("2")
      console.log("Value", value);
      this.edittemp_WHcity = [];
      console.log(this.WHData)
      for (var i = 0; i < this.WHData.length; i++) {
        for (var j = 0; j < value.length; j++) {
          if (this.WHData[i].sourcecity == value[j]) {
            let cityWH = {
              city: this.WHData[i].sourcecity,
              warehouseid: value[j].toString(),
            };

            this.edittemp_WHcity.push(cityWH);
            // this.zonecustomer.zone_mapcity=this.edittemp_WHcity
            // console.log("edittemp_WHcity", this.edittemp_WHcity);
          }
        }
      }
    },

    validateForm2(scope){
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.editzonedata();
        }
      });
    },

    editzonedata(){
      document.getElementById("overlaymodel").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const zoneObj= {
        lastmodifiedby :  `${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
        creatersysusermasterid: `${this.editsysusermasterid}`,
        zoneno : `${ this.zonecustomer.zone_number}`,
        zonetitle : `${this.zonecustomer.zone_name}`,
        zone_city : this.zonecustomer.zone_mapcity,
        zoneid : this.editzonid,
        is_asn:'YES',
        hub_id : this.edithub_id,
        zonetype : this.zonecustomer.zone_selecttype,
      }
      
      console.log("zoneObj", zoneObj);
      // return false;
      // if (this.getPincodes.length !=0) {
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/editAdminZoneListing`,zoneObj)
        .then((result) => {
          // alert("Api")
          document.getElementById("overlaymodel").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Added Successfully",
              type: "success",
              timer: 30000,
            });
            this.ZoneListings();
            this.zonecustomer = {
              zone_mapcity : []
            };
            this.editzonid = '';
            this.errors.clear("form-3");
            this.editmodel= !this.editmodel;
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    LogDetailsModal(value){
      console.log(value)
      this.zonelogDetails = [];
      this.logdetailsModal = !this.logdetailsModal;
      const Obj= {
        zoneid: value.zoneid
      }
      console.log(Obj)

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getzonelogdetails`,Obj)
        .then((result) => {
          console.log("list",result)
          if (result.body.returnmsg === "Successful") {
            this.zonelogDetails = result.body.returnvalue;
            this.totallogcount = result.body.returnvalue.length;
            console.log(this.totallogcount)
            console.log("zonelogDetails",this.zonelogDetails)
          } 
          else {
            this.zonelogDetails = result.body.returnvalue;
            this.totallogcount = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    editLBHModal(value,type){
      console.log(value)
      this.selected_zone_id = value.zoneid;
      this.Customer.selectedredio=value.zonetype;
      this.Customer.length=parseFloat(value.length)/12;
      this.Customer.breadth=parseFloat(value.breadth)/12;
      this.Customer.height=parseFloat(value.height)/12;
      this.Customer.zonestatus = value.zonestatus
      this.editLBH =! this.editLBH;
     
      // console.log("Value@@@@@@@@@@@@",value,type);
    },

    validateForm3(scope){
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.editLBHdata();
        }
      });
    },

    editLBHdata(){
      document.getElementById("overlaymodel").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const Obj= {
          creatersysusermasterid: `${userInfo.sysusermasterid}`,
          lastmodifiedby:`${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
          zonetype: `${this.Customer.selectedredio}`,
          length:this.Customer.length,
          breadth:this.Customer.breadth,
          height:this.Customer.height,
          zoneid:this.selected_zone_id,
        
          // is_asn:'NO',

      }
      console.log(Obj)

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/updateZoneDetails`,Obj)
        .then((result) => {
          document.getElementById("overlaymodel").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.editLBH =! this.editLBH;  
            this.ZoneListings();
            this.Customer={};
            this.selected_zone_id='';
          }else{
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    //hub list 

    hubDashboardcount : function(){
      this.isLoading=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`
        } 
        console.log("obj",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getallhubtohubcount`,obj)
          .then(result => {
            this.isLoading=false;
            if (result.body.returnmsg === "Successful") {
            this.hubCount=result.body.returnvalue;
            this.hubcount_length=result.body.returnvalue.length;
            }else{
                this.hubCount=[];
                this.hubcount_length=0;
            }
          }).catch(ex => {
            console.log("error", ex);
               });
    },

    editactiveinactive(zoneid, status){
      this.Customer.zonestatus =null
      console.log(zoneid, status)
      this.selected_zone_id = zoneid
      this.selected_zone_status = status
      this.editactiveinactivezone = true
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.editzonestatus();
        }
      });
    },

    editzonestatus() {
    if (this.Customer.zonestatus == '0') {
      this.$bvModal
        .msgBoxConfirm(
          'Are you sure you want to mark this zone as inactive? This zone will not be available for future operations.',
          {
            title: 'Confirmation',
            okTitle: 'Yes',
            cancelTitle: 'No',
            centered: true,
            size: 'md'
          }
        )
        .then(value => {
          if (value) {
            this.updateZoneStatus();
          }
        });

      return;
    }

  // Active selected
      this.updateZoneStatus();
    },

    updateZoneStatus() {
        this.isLoading = true;

        const userdata = localStorage.getItem("userData");
        const userInfo = JSON.parse(userdata);

        const obj = {
          sysemailid: userInfo.sysemailid,
          zoneid: this.selected_zone_id,
          zonestatus: this.Customer.zonestatus
        };

        console.log("obj", obj);

        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/editzonestatus`, obj)
          .then(result => {
            this.isLoading = false;

            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 3000
              });
              this.ZoneListings(this.selected_hubid);
              this.editactiveinactivezone = false;
              
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 3000
              });
            }
          })
          .catch(ex => {
            this.isLoading = false;
            this.editactiveinactivezone = false;
            this.ZoneListings(this.selected_hubid);
            console.log("error", ex);
          });
      }


  },
};
</script>

<style>
.selectbutton span {
  font-weight: 599 !important;
}

.logmodel table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.logmodel th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.logmodel td{
  text-align: left;
  padding: 8px;
}

.logmodel tr:nth-child(even) {
  background-color: #eeee;;
}

.square-checkbox .custom-control-input ~ .custom-control-label::before {
  border-radius: 0 !important;
}
</style>
